<template>
  <b-container class="site-detail__reportsettings contentcontainer">
    <b-row class="contentcontainer__head">
      <b-col>
        <h2>{{$t('config.settingsautobackup')}}</h2>
      </b-col>
    </b-row>
    <hr/>
    <b-row>
      <b-col>
        <div class="form-group--bmswitch">
          <div class="form-group--bmswitch__switch">
            <b-form-checkbox
              v-on:change="localAutobackupChange"
              v-model="enabled"
              class="bmswitch"
            ></b-form-checkbox>
            <span class="text--uppercase text-smallest text--muted" v-if="global">
              {{ $t('config.globalsetting') }}
            </span>
          </div>
          <div class="form-group--bmswitch__label">
            {{ $t('config.autobackupintro') }}
          </div>
        </div>

      </b-col>
    </b-row>
  </b-container>
</template>

<script>

import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'

import mixins from '../../mixins'

export default {

  name: 'SiteDetailSettingsAutobackup',

  mixins: [mixins],

  computed: {

    ...mapState('site', [
      'siteDetail'
    ]),
    ...mapGetters('user', {
      account: 'getAccount'
    }),

    global () {
      return this.autobackup === -1
    },

    globalAutobackupSetting () {
      if (this.account.config) {
        return this.account.config.autobackup
      }

      return false
    },

    enabled: {
      get () {
        return this.globalAutobackupSetting === true || this.autobackup === 1
      },
      set (value) {
        // just do nothing
      }
    }
  },

  data () {
    return {
      autobackup: -1
    }
  },

  watch: {

    'siteDetail': function () {
      this.preparePage()
    }
  },

  methods: {

    ...mapMutations('site', [
      'closeSiteDetailPageConfiguration'
    ]),

    ...mapActions('site', [
      'saveSiteConfiguration'
    ]),

    ...mapActions('user', [
      'getAccount'
    ]),

    localAutobackupChange () {
      let value = 1
      if (this.autobackup === -1) {
        if (this.globalAutobackupSetting) {
          value = 0
        }
      } else {
        if (this.autobackup === 1) {
          value = 0
        }
      }

      this.autobackup = value
      this.save()
    },

    preparePage () {
      // check for initial state
      if (this.siteDetail.data.configuration === null) {
        // default value
        this.autobackup = -1

        return
      }

      this.autobackup = this.getConfigValue(
        this.siteDetail.data.configuration,
        'autobackup',
        -1
      )
    },

    save () {
      let payload = {
        id: this.siteDetail.id,
        configuration: {
          'autobackup': this.autobackup
        }
      }

      this.saveSiteConfiguration(payload)
    }
  },

  mounted () {
    this.getAccount()
  }
}
</script>
